import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Marquee } from "../components/store/Marquee";
import { FreeBox } from "../components/store/FreeBox";
import { HomeHero } from "../components/home/HomeHero";
import { StepsSection, CategoriesSection, FeaturedSection, WhySection } from "../components/home/HomeSections";
import { ReviewsSection } from "../components/home/HomeReviews";
import { BundleSection } from "../components/home/BundleSection";
import { PackagingSection, GlutenFitBanner } from "../components/home/HomeEco";

export default function Home() {
  const [featured, setFeatured] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [bundle, setBundle] = useState(null);

  useEffect(() => {
    api.get("/products", { params: { featured: true } }).then((r) => {
      if (r.data.length > 0) return setFeatured(r.data.slice(0, 4));
      api.get("/products").then((r2) => setFeatured(r2.data.slice(0, 4))).catch(() => {});
    }).catch(() => {});
    api.get("/reviews/featured", { params: { limit: 6 } }).then((r) => setReviews(r.data)).catch(() => {});
    api.get("/products/box-degustazione-best-seller").then((r) => setBundle(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="home-page">
      <HomeHero />
      <Marquee />
      <StepsSection />
      <CategoriesSection />
      <FeaturedSection featured={featured} />
      <BundleSection bundle={bundle} />
      <ReviewsSection reviews={reviews} />
      <FreeBox />
      <PackagingSection />
      <GlutenFitBanner />
      <WhySection />
      <Marquee dark />
    </div>
  );
}
